import {
    isOrderItem,
    isOrderItemAccommodation,
    isOrderItemAccommodationRateItem,
    isOrderItemBookable,
    isOrderItemBookableQuantity,
    isOrderItemDiscount,
    isOrderItemGiftCard,
    isOrderItemOptional,
    isOrderItemUsedGiftCard,
    isOrderItemVoucher,
} from "./is-order-item";
import {
    getChildAccommodationRates,
    getChildOptionals,
    getChildQuantities,
    getProductIds,
    isOrderItemWithProduct,
    orderItemHasProduct,
} from "./order-item-v2-helper";

const orderItemUtils = {
    typeCheck: {
        isOrderItem,
        isOrderItemWithProduct,
        isAccommodation: isOrderItemAccommodation,
        isAccommodationRateItem: isOrderItemAccommodationRateItem,
        isBookable: isOrderItemBookable,
        isBookableQuantity: isOrderItemBookableQuantity,
        isDiscount: isOrderItemDiscount,
        isGiftCard: isOrderItemGiftCard,
        isOptional: isOrderItemOptional,
        isUsedGiftCard: isOrderItemUsedGiftCard,
        isVoucher: isOrderItemVoucher,
    },
    hasProduct: orderItemHasProduct,
    getAccommodationRates: getChildAccommodationRates,
    getQuantities: getChildQuantities,
    getOptionals: getChildOptionals,
    getProductIds: getProductIds,
};

export { orderItemUtils };
